<template>
  <v-menu v-model="show">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :id="id"
        :loading="loading"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ icon.dotsVertical }}</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar class="justify-center mr-1">
              <span>
                <v-icon>{{ icon.fileOutline }}</v-icon>
              </span>
          </v-list-item-avatar>

          <v-list-item-content >
            <v-list-item-title style="max-width: 180px;">{{ document.descripcion }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <document-view
          v-model="document"
          :id="`documents_table__visualizar__list` + document.clave"
          type="list"
          @click="close"
        />
        <document-update
          v-if="canUpdate"
          v-model="document"
          :id="`documents_table__actualizar__list` + document.clave"
          type="list"
          @click="close"
        />
        <document-delete
          v-if="canCancelOrDelete"
          :document="document"
          :id="`documents_table__eliminar__list` + document.clave"
          type="list"
          @click="close"
        />
        <document-generate-constancy
          v-if="signersValidation"
          :document="document"
          :id="`documents_table__constancia__list` + document.clave"
          type="list"
          @click="close"
        />
        <document-constancy-download
          :document="document"
          :id="`documents_table__descargapdf__list` + document.clave"
          format="pdf"
          type="list"
          @busy="busy"
          @unoccupied="unoccupied"
        />
        <document-constancy-download
          :document="document"
          :id="`documents_table__descargaxml__list` + document.clave"
          format="xml"
          type="list"
          @busy="busy"
          @unoccupied="unoccupied"
        />
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiDotsVertical, mdiFileOutline } from '@mdi/js';
import DocumentView from '../DocumentView'
import DocumentUpdate from '../DocumentUpdate'
import DocumentDelete from '../DocumentDelete'
import DocumentGenerateConstancy from '../DocumentGenerateConstancy'
import DocumentConstancyDownload from './DocumentConstancyDownload'

export default {
  name: 'DocumentActionsMenu',
  components: {
    DocumentView,
    DocumentUpdate,
    DocumentDelete,
    DocumentGenerateConstancy,
    DocumentConstancyDownload
  },
  props: {
    value: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      icon: {
        dotsVertical: mdiDotsVertical,
        fileOutline: mdiFileOutline
      },
      show: false,
      loading: false
    }
  },
  computed: {
    document: {
      get() {
        return Object.assign({}, this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    canUpdate() {
      return this.document.estatus.descripcion == 'Pendiente' ||
        this.document.estatus.descripcion == 'En proceso' ||
        this.document.estatus.descripcion == 'Expirado'
    },
    canCancelOrDelete() {
      return this.document.estatus.descripcion != 'Cancelado' && 
        this.document.estatus.descripcion != 'Firmado'
    },
    isSigned() {
      return this.document.estatus.descripcion == 'Firmado'
    },
    signersValidation() {
      let list = this.document.firmantes.filter(s => s.firmado)
      return list.length == this.document.firmantes.length && this.document.estatus.descripcion == 'En proceso' 
    }
  },
  methods: {
    close() {
      this.show = false
    },
    busy() {
      this.loading = true
    },
    unoccupied() {
      this.loading = false
    }
  }
}
</script>